module.exports = __webpack_public_path__ + "static/media/drumnow-3.8ef173a8.jpg";